<template>
  <div>
       <AppHeader v-on:menuToggle="closeMenu" :chkVal="isToggled" />
          <section id="main">
          <aside id="sidebar"  v-if ="IsAuth" v-on:click="closeMenu(false)" v-bind:class="{ toggled: isToggled }">
              <sidebar-menu></sidebar-menu>
          </aside>
          <div class="clsSidebar" v-on:click="closeMenu(false)" v-bind:class="{ maskToggled: isToggled }"></div>
            <section id="content"> 
              <div class="container">
              <transition name="fade" mode="out-in">
                <slot></slot>
                <!-- <router-view></router-view> -->
              </transition>
            </div>
      </section> 
      </section>
      <AppFooter/>
   </div>
</template> 
<script>
import AppHeader from '../../Common/Default/AppHeader.vue'
 import SidebarMenu from '../../Common/Default/SideNav.vue';
 import AppFooter from '../../Common/Default/AppFooter.vue';
 import {router} from '@/router/AllRoutes';
export default {
 name: "LayoutDefault",
  data() {
    return {
      user: null,
       //isToggled: false,
    };
  },
  components: {
    AppHeader,
    SidebarMenu,
    AppFooter
  },
  computed: {
         
          IsAuth () {  
              //alert(this.$store.getters.IsAuth)
             return this.$store.getters.IsAuth;
          },
         isToggled: {
              // getter
              get: function () {
                 return this.$store.getters.GetToggle;
              },
              // setter
              set: function (val) { 
                 this.$store.dispatch('ChangeToggle',val);
          },
         }
         
    },
     watch: { 
      IsAuth : function()
      {
        return this.$store.getters.IsAuth;
      },
        isToggled(){
                return this.$store.getters.GetToggle;
            }
    },
    methods: {
     closeMenu(val) {
        this.isToggled = val;
      }
    },
  
  created() {
    // Simulate fetching user data.
    //setTimeout(() => {
      //this.user = { name: `John Doe` };
   // }, 2000);
  },

  beforeCreate: function() {   
    const auth = this.$store.getters.IsAuth;
    if (!auth) {
      router.push({ name: 'home' });
    }
    }, 
};
</script>
 <style lang="scss">
.container,
.container-fluid {
  /*padding-left: 15px;
    padding-right: 15px;
    margin-right: auto;
    margin-left: auto;*/
  padding-left: 10px;
  padding-bottom: 5px;
}

#content {
  height: calc(100vh - 100px);
  //height: calc(100vh - 80px);
  padding-top: 10px;
  position: relative;
  // border-right: 1px solid #eee;
  // overflow-y: auto;
  // border-right: 1px solid #eee;
  //  padding-left: 240px !important;
}

#content .container {
  max-width: 100%;
  padding-left:5px !important;
}
#content ul {
  padding-left: 1.9em;
}
#content ol {
  padding-left: 1.4em;
}
#content li {
  margin-bottom: 0.4rem;
}
#content a {
  font-weight: bold;
}
#content a:hover {
  text-decoration: underline;
}

.clsSidebar {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 9;
  cursor: pointer;
  display: none;
}
.PopUpHeader {
  background-color: #B9D9EB; 
} 
.PopUpTitle {
  margin-bottom:0;
  padding: 2px;
  line-height:1.5;
  font-size: 1.1rem;
  font-weight: normal; 
}
.BtnSave {
  background-color: #B9D9EB;
} 
.BtnClose {
  background-color: #046A38;
  color: white;
} 
 
#sidebar {
  padding: 5px 0;
  position: fixed;
  background: #fff;
  width: 230px;
  height: calc(100% - 70px);
  top: 70px;
  overflow-y: auto;
  transition: all;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  z-index: 10;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  border-right: 1px solid #eee;
}

#main {
  position: relative;
}

#main {
  /*padding-bottom: 60px;*/
  padding-top: 70px;
  height: calc(100vh - 70px);
}
.text-pm
{
  background-color:#B9D9EB !important
}
a.text-pm:hover,a.text-pm:focus
{
  color:#3B434A !important
}
.modal .modal-huge {
max-width: 100% !important;
margin: 0;
top: 0;
bottom: 0;
left: 0;
right: 0;
height: 100% !important;
display: flex;
position:absolute fixed;
}
.alert-warning{
  background-color:#B9D9EB !important;
}
.alert-success{
  background-color:#F5F5F5 !important;
}
// .AddModal .modal-dialog {
// max-width: 100%;
// margin: 0;
// top: 0;
// bottom: 0;
// left: 0;
// right: 0;
// height: 100vh;
// display: flex;
// z-index: 100000;
// }
.Maintitle   {
  background-color: #f7f7f7;
  border-left: 5px solid #FBDD40 !important;
  padding: 0px 5px 5px 5px;
  display: block;
  //font-weight: 500;
  position: relative;
  font-size: 18px;
  /* margin: 10px 0; error*/ 
  color: #4c4c4c;
  border-left: 5px solid #fff;
  -o-transition: color 0.2s linear, background 0.2s linear;
  -moz-transition: color 0.2s linear, background 0.2s linear;
  -webkit-transition: color 0.2s linear, background 0.2s linear;
  transition: color 0.2s linear, background 0.2s linear;
}
.Subtitle   {
  background-color: #f7f7f7;
  border-left: 5px solid #ff9800 !important;
  padding: 0px 5px 5px 5px;
  display: block;
  //font-weight: 500;
  position: relative;
  font-size: 14px;
  /* margin: 10px 0; error*/ 
  color: #4c4c4c;
  border-left: 5px solid #fff;
  -o-transition: color 0.2s linear, background 0.2s linear;
  -moz-transition: color 0.2s linear, background 0.2s linear;
  -webkit-transition: color 0.2s linear, background 0.2s linear;
  transition: color 0.2s linear, background 0.2s linear;
}
.Hometitle   {
  background-color: #f7f7f7;
  //border-left: 5px solid #ff9800 !important;
  //padding: 0px 5px 5px 5px;
  display: block;
  //font-weight: 500;
  position: relative;
  font-size: 14px;
  /* margin: 10px 0; error*/ 
  color: #4c4c4c;
  //border-left: 5px solid #fff;
  -o-transition: color 0.2s linear, background 0.2s linear;
  -moz-transition: color 0.2s linear, background 0.2s linear;
  -webkit-transition: color 0.2s linear, background 0.2s linear;
  transition: color 0.2s linear, background 0.2s linear;
}
@media (min-width: 1200px) {
  #content:not(.content-alt) {
    padding-left: 230px !important;
    //padding-left: 0 !important;
    padding-right: 0px;
  }
}
@media (min-width: 992px) {
  .modal .modal-huge {
    max-width: 100% !important;
    width: 100% !important; 
    height: 100% !important; 
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0; 
    display: flex;
    position:absolute fixed; 
  }
}

// @media (min-width: 992px) {
//   .modal .modal-md {
//     max-width: 600px !important;
//     width: 600px !important; 
//     height: 700px !important;  
//     display: flex;
//     position:absolute fixed; 
//   }
// }

@media (max-width: 1199.98px) {
  #sidebar {
    -webkit-transform: translate3d(-230Sx, 0, 0);
    transform: translate3d(-230px, 0, 0);
    box-shadow: 0 0 20px rgba(14, 18, 21, 0.38);
  }

  #sidebar.toggled {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  .maskToggled {
    display: block;
  }
}

@media screen and (max-width: 767.98px) {
  #content {
    height: calc(100vh - 80px);
  }
  #content .container {
    padding-left: 5px;
    padding-right: 7px;
  }
}

@media print {
  #main {
    padding-top: 0px;
  }
  #content {
    padding-left: 0 !important;
  }
  #content > .container {
    padding: 0 !important;
  }
}
</style>
